import * as React from "react";
import ExternalLink from "../../../../../../../components/Navigation/ExternalLink";
import { buildServerPackagingInstruction } from "../../Instructions";
import { CommonTextForOctopusCli, CommonBuildServerPackagingTextForIntegration } from "../CommonRegistrationText";
export const AspNetBuildServerPackaging: React.FC<{}> = () => (<div>
        <p>
            When packaging .NET applications from build servers, we have extensions available that use the{" "}
            <ExternalLink href={"cli"} label={"Octopus CLI"}>
                Octopus CLI
            </ExternalLink>{" "}
            to package your application behind the scenes.
        </p>
        {CommonTextForOctopusCli}
        {CommonBuildServerPackagingTextForIntegration}
        <p>
            The <ExternalLink href="GuidesASPNet">ASP.NET guides</ExternalLink> provide step by step instructions for deploying ASP.NET applications.
        </p>
    </div>);
AspNetBuildServerPackaging.displayName = "AspNetBuildServerPackaging"
export default buildServerPackagingInstruction(() => <AspNetBuildServerPackaging />);
